import { translate } from "shared/languages";

/**
 * Single source for the two admin cancellation outcomes (Batalkan / No Show),
 * shared by the per-row cancel modal (ScheduleBooking) and the bulk cancel
 * modal (bookingConfirmModals) so their labels cannot drift.
 *
 * The two modals bind different form values (BookingStatus vs the legacy
 * `isRefund` boolean), so each caller supplies its own `value` pair; the
 * labels stay shared.
 */
export type CancelTypeOption<T> = {
  value: T;
  label: string;
};

export const buildCancelTypeOptions = <T,>(values: {
  cancelled: T;
  noShow: T;
}): CancelTypeOption<T>[] => [
  { value: values.cancelled, label: translate("label.cancel") },
  { value: values.noShow, label: translate("label.no_show") },
];
